<template>
  <div class="list-container">
    <!-- breadCrumb -->
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.seatBreadCrumb"></ZD-bread-crumb>
    </div>

    <div class="list-content-div" style="padding-bottom: 0;">
      <div class="list-header-title-div">占位费设置</div>

      <div
        class="detail-content-body-div flex-1"
        style="padding: 24px 0; box-sizing: border-box; "
      >
        <el-form
          :model="detailForm"
          :rules="seatFormRules"
          ref="seatRef"
          label-width="120px"
          class="detail-form"
        >
          <div class="flex-c detail-form-parent-div">
            <el-form-item label="基础费用：" prop="basicFee">
              <div>
                <el-input
                  style="width: 320px;"
                  v-model="detailForm.basicFee"
                  size="small"
                ></el-input>
                <span style="margin-left: 15px">元/每分钟</span>
              </div>
              <span style="color: #bbb;"
                >（占位计费单价，输入范围 0.01~10.00）</span
              >
            </el-form-item>
            <el-form-item label="空闲率标准：" prop="freeRate">
              <div>
                <el-input
                  style="width: 320px;"
                  v-model="detailForm.freeRate"
                  size="small"
                ></el-input>
                <span style="margin-left: 15px">% 空闲率进行占位计算</span>
              </div>
              <div style="color: #bbb;">
                （输入范围 10~100，100% 表示任何空闲情况都计费）
              </div>
            </el-form-item>
            <el-form-item label="占位免计时间：" prop="freeTime">
              <div>
                <el-input
                  style="width: 320px;"
                  v-model.number="detailForm.freeTime"
                  size="small"
                ></el-input>
                <span style="margin-left: 15px">分钟</span>
              </div>
              <div style="color: #bbb;">
                （如占位免计时间设为 60 分钟，表示直到 60 分钟后开始计算占位，0
                表示停充后即进入占位期）
              </div>
            </el-form-item>
            <el-form-item label="计费缓冲时间：" prop="bufferTime">
              <div>
                <el-input
                  style="width: 320px;"
                  v-model.number="detailForm.bufferTime"
                  size="small"
                ></el-input>
                <span style="margin-left: 15px">分钟</span>
              </div>
              <div style="color: #bbb;">
                （请输入大于等于 0 的整数数字，0 则表示没有缓冲时间）
              </div>
            </el-form-item>
            <el-form-item label="每日最高上限：" prop="maxFeeStatus">
              <el-radio-group v-model="detailForm.maxFeeStatus">
                <el-radio label="01">启用</el-radio>
                <el-radio label="02">不启用</el-radio>
              </el-radio-group>
              <div>
                <div>
                  <el-input
                    style="width: 320px;"
                    size="small"
                    v-model.number="detailForm.maxFee"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    :disabled="detailForm.maxFeeStatus == '02'"
                  ></el-input>
                  <span style="margin-left: 15px">元</span>
                </div>
                <div style="color: #bbb;">
                  （请输入大于等于 0 的整数数字，0 则表示没有缓冲时间）
                </div>
              </div>
            </el-form-item>
            <el-form-item label="占位费说明：">
              <div>
                车辆充电完成（停止充电）后，如未拔枪结束订单，则是为停充占位，
                {{ "60" }} 分钟后开始计占位费
                （计费标准：占位期间本电站内空闲桩少于 {{ "80" }}%
                的时段，按每分钟{{ "10" }}元累计占位费，如未满{{
                  "60"
                }}分钟结束充电的短时订单，统一按
                {{ "60" }}分钟后才开始计算展位时间，每日最高占位费上限{{
                  "60"
                }}元，如每日占位费超出{{ "60" }}元上限，按{{ "10" }}元收取。）
              </div>
            </el-form-item>
          </div>
        </el-form>

        <div class="detail-container" style="margin-top: 24px;">
          <div class="detail-content-footer-div">
            <button class="common-bg-button" @click="submitForm('seatRef')">
              提 交
            </button>
            <button class="common-empty-button" @click="resetForm()">
              取 消
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      detailForm: {},
      seatFormRules: {
        basicFee: [
          { required: true, message: "请输入基础费用", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              let reg = /^([0-9]*)+(\.[0-9]{1,2})?$/;
              if (reg.test(parseFloat(value))) {
                if (parseFloat(value) < 0.01) {
                  callback(new Error("输入范围 0.01~10.00，请重新键入"));
                } else {
                  callback()
                }
                if (parseFloat(value) > 10.0) {
                  callback(new Error("输入范围 0.01~10.00，请重新键入"));
                } else {
                  callback()
                }
              } else {
                if (parseFloat(value).toString() == "NaN") {
                  callback(new Error("请输入数字"));
                }else {
                  callback()
                }
                if (value.length > 4) {
                  callback(new Error("请保留两位小数"));
                } else {
                  callback()
                }
              }
            },
            trigger: "blur",
          },
        ],
        freeRate: [
          { required: true, message: "请输入空闲率标准", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (!/^([1-9][0-9]*)+(\.[0-9]{1,2})?$/.test(parseInt(value))) {
                if (parseFloat(value).toString() == "NaN") {
                  callback(new Error("请输入数字"));
                }
                callback(new Error("输入范围 10~100，请重新键入"));
              } else {
                if (parseFloat(value) < 10) {
                  callback(new Error("输入范围 10~100，请重新键入"));
                } else {
                  callback()

                }
                if (parseFloat(value) > 100) {
                  callback(new Error("输入范围 10~100，请重新键入"));
                } else {
                  callback()

                }
              }
            },
            trigger: "blur",
          },
        ],
        freeTime: [
          { required: true, message: "请选择占位免计时间", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (parseInt(value) == 0) {
                callback();
              } else {
                  callback()

                }
              if (/^-[1-9]\d*$/.test(value)) {
                callback(new Error("请输入大于等于0的正整数"));
              }else {
                  callback()

                }
            },
            trigger: "blur",
          },
        ],
        bufferTime: [
          { required: true, message: "请输入计费缓冲时间", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (parseInt(value) == 0) {
                callback();
              }
              if (/^-[1-9]\d*$/.test(value)) {
                callback(new Error("请输入大于等于0的正整数"));
              }else {
                  callback()

                }
            },
            trigger: "blur",
          },
        ],
        maxFeeStatus: [
          { required: true, message: "请选择每日最高上限", trigger: "change" },
        ],
        maxFee: [
          {
            validator: (rule, value, callback) => {
              if (parseInt(value) == 0) {
                callback();
              }else {
                  callback()

                }
              if (/^-[1-9]\d*$/.test(value)) {
                callback(new Error("请输入大于等于 0 的整数数字"));
              }else {
                  callback()

                }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let _ = this;
      _.$U.showLoading(_);
      _.$H
        .post(_, _.$A.pilestation.occupyFee, {
          occupyNo: _.$route.query.occupyNo,
        })
        .then((res) => {
          _.detailForm = res.data.data || {
            basicFee: "",
            freeRate: "",
            freeTime: "",
            bufferTime: "",
            maxFee: "",
            maxFeeStatus: "02",
          };
          _.$U.hideLoading(_);
        });
    },
    // 提交
    submitForm(formName) {
      console.log(31231321);

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$U.showLoading(this);
          this.detailForm.occupyNo = this.$route.query.occupyNo || "";
          this.detailForm.stationNo = this.$route.query.stationNo || "";
          this.$H
            .post(this, this.$A.pilestation.editSeat, this.detailForm)
            .then((res) => {
              this.$U.hideLoading(this);
              this.$router.push({
                name: pageConfig.listRouter,
              });
            });
        } else {
          console.log(valid, "0");
        }
      });
    },

    // 取消
    resetForm() {
      debugger;
      let _ = this;
      _.$router.push({ name: "pileStationList" });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-form-item {
  margin-bottom: 16px;
}

/deep/ .detail-content-footer-div .el-form-item__content {
  margin-left: 0 !important;
}
/deep/ .detail-content-footer-div .el-form-item {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}
</style>
